export const add = () => ({ type: 'ADD' });
export const subtract = () => ({ type: 'SUBTRACT' });
export const login = (token) => ({ type: 'LOGIN', token });
export const logout = () => ({ type: 'LOGOUT' });
